import { StateSchema } from 'app/config/storeConfig/types';

let cachedIds: string[] = [];

/**
 * Returns the ids of every shape currently placed on the map, in
 * placement order. Intended to be subscribed to with `shallowEqual` so
 * that high-frequency mutations (selection toggle, drag, transform) do
 * not invalidate consumers — only add / delete / reorder of shapes
 * does. Used by the box picker to keep its derived state stable while
 * the user marquee-selects or drags shapes.
 */
export const getPlacedShapeIds = (state: Pick<StateSchema, 'warehouseMapConstructor'>): string[] => {
  const { shapes } = state.warehouseMapConstructor;
  if (cachedIds.length === shapes.length && shapes.every((shape, index) => shape.id === cachedIds[index])) {
    return cachedIds;
  }

  cachedIds = shapes.map((shape) => shape.id);
  return cachedIds;
};
